import { Action } from 'redux'
import { RepoState, Dictionary, DKKPriceItem } from '../../typings/repo';
import { getProductLine } from 'utils/utils';

interface SetRepoAction extends Action<"SET_REPO">
{
    repo: RepoState;
}

interface SetPricesAction extends Action<"SET_PRICES">
{
    prices: Dictionary<DKKPriceItem>;
}

export const setLanguage = (lang: string) => {
  const productLine = getProductLine();
  let repo;
  try {
    repo = require(`../repository-data/${productLine}/repository-${productLine}-${lang}.json`);
  } catch (e) {
    console.log(e)
    repo = require(`../repository-data/grey/repository-grey-en.json`);
  }

  return { type: "SET_REPO", repo }
}

interface ResetPricesAction extends Action<"RESET_PRICES">
{
    langCode: string;
    productLine: string;
}

export const setPrices = (prices: Dictionary<DKKPriceItem>): SetPricesAction => ({
  type: "SET_PRICES",
  prices
});

export const resetPrices = (langCode: string, productLine: string): ResetPricesAction => ({
  type: "RESET_PRICES",
  langCode,
  productLine
});

export type RepoAction = SetRepoAction | SetPricesAction | ResetPricesAction;